import * as React from 'react';
import './SectionImages.css';
import { ClassNames } from '../../_helpers/ClassNames';
import { SectionImagesDto } from 'src/@types/api';
import { Image } from '../Image/Image';
export type SectionImagesProps = SectionImagesDto & {
    ImageMode: boolean;
    RequestFullScreen: (e: React.MouseEvent<HTMLElement>) => void;
};
type State = { active: number; };

const DELAY = 6000;

export class SectionImages extends React.Component<SectionImagesProps, State> {
    private maxPadding: number
    private timeoutId: NodeJS.Timeout;

    constructor(props: SectionImagesProps) {
        super(props);

        this._Next = this._Next.bind(this);
        this._AutoNext = this._AutoNext.bind(this);

        this.state = {
            active: 0
        };

        this.maxPadding =
            this.props.Images.map(image => image.Width ? (image.Height / image.Width) * 100 : 0).sort()[0];
    }

    componentDidMount() {
        this._AutoNext();
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    render() {
        const { Images, ImageMode, RequestFullScreen } = this.props;
        const { active } = this.state;

        return (
            <div
                className={ClassNames("section-images", "", ImageMode ? "image-mode-enabled" : "")}

            >

                <figure className={ClassNames("section-images", "image")}>
                    <div
                        className={ClassNames("section-images", "image-wrap")}
                        onClick={(e) => ImageMode ? this._Next() : RequestFullScreen(e)}
                    >
                        <div className={ClassNames("section-images", "images")}>
                            {Images.map((image, index) => (
                                <Image
                                    key={index}
                                    pictureRef={image}
                                    className={ClassNames("section-images", "img", index === active && "show")}
                                    sizes={"(max-width: 766px) 100vw, (min-width: 767px) 40vw"}
                                />
                            ))}
                        </div>
                        <div
                            className={ClassNames("section-images", "image-ratio")}
                            style={{ paddingBottom: `${this.maxPadding}%` }}
                        />
                    </div>
                    <div className={ClassNames("section-images", "infos")}>

                        <div className={ClassNames("section-images", "controls", Images.length === 1 && "unique")}>
                            {Images.map((image, index) => (
                                <a
                                    key={index}
                                    className={ClassNames("section-images", "bullet", index === active && "active")}
                                    onClick={() => this._Go(index)}
                                />

                            ))}
                        </div>
                        <div className={ClassNames("section-images", "legend")}>
                            {Images.map((image, index) => {
                                const regExp = /\$([^\$]*)\$/gi;
                                const legend =
                                    image.Legend.replace(regExp, (m, g) => `<em>${g}</em>`).replace(/\n/g, '<br />');
                                return (
                                    <figcaption
                                        key={index}
                                        className={
                                            ClassNames("section-images", "legend-item", index === active && "show")}
                                        style={{
                                            marginLeft:
                                                index <= 1 ? `${-100 * index}%` : `-100%`
                                        }}
                                        dangerouslySetInnerHTML={{ __html: legend }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </figure>
            </div>
        );
    }

    // {image.Legend.split(/\n/g).map((part, i) =>
    //     <React.Fragment key={i}>{i !== 0 ? <br /> : null}{part}</React.Fragment>
    // )}

    private _Next() {
        const count = this.props.Images.length;
        const { active } = this.state;

        this._Go((active + 1) % count);
    }

    private _Go(active: number) {
        clearTimeout(this.timeoutId);
        this.setState(
            () => ({ active }),
            this._AutoNext
        );
    }
    private _AutoNext() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(this._Next, DELAY);
    }
}

export default SectionImages;


// WEBPACK FOOTER //
// ./src/Components/SectionImages/SectionImages.tsx